import { Link } from 'react-router-dom';
import { characters } from '@/mocks/characters';
import SectionTitle from '@/components/base/SectionTitle';

export default function CharSection() {
  const featured = characters.slice(0, 4);
  return (
    <section className="w-full bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionTitle
          mark="人物"
          title="核心人物一览"
          subtitle="从稳健的师兄李长寿，到温柔的小师妹蓝灵娥——先把这群人认全，磕糖才有方向。"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featured.map((c) => (
            <Link
              key={c.id}
              to="/characters"
              className="group relative flex flex-col overflow-hidden rounded-xl border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="relative h-56 w-full overflow-hidden md:h-60">
                <img
                  src={c.image}
                  alt={c.name}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-950/60 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
                  {c.faction}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {c.name}
                </h3>
                <p className="mt-0.5 text-xs text-foreground-500">{c.alias}</p>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-6 text-foreground-600">{c.desc}</p>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center">
          <Link
            to="/characters"
            className="font-seal inline-flex items-center gap-2 rounded-md border border-primary-300 px-6 py-3 text-lg text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
          >
            查看完整人物关系图谱 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}